module.exports = __webpack_public_path__ + "assets/img/ability43.1c572b09.png";